var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGames(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "14px",
    viewBox: "0 0 28 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSketch: "http://www.bohemiancoding.com/sketch/ns",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    sketchType: "MSPage"
  }, /*#__PURE__*/React.createElement("g", {
    id: "screens/review",
    sketchType: "MSArtboardGroup",
    transform: "translate(-814.000000, -37.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu",
    sketchType: "MSLayerGroup",
    transform: "translate(47.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "game",
    transform: "translate(764.000000, 27.000000)",
    sketchType: "MSShapeGroup"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,6.9625 C3,11.0375 6.09375,14 9.91875,14 L24.08125,14 C27.90625,14 31,11.0375 31,6.9625 C31,2.8875 27.90625,0 24.08125,0 L9.91875,0 C6.09375,0 3,2.89375 3,6.9625 L3,6.9625 Z M26.3,5.58125 C26.96875,5.58125 27.5125,6.1125 27.5125,6.76875 C27.5125,7.425 26.96875,7.95625 26.3,7.95625 C25.63125,7.95625 25.0875,7.425 25.0875,6.76875 C25.0875,6.1125 25.63125,5.58125 26.3,5.58125 L26.3,5.58125 Z M23.64375,2.9875 C24.31875,2.9875 24.8625,3.51875 24.8625,4.175 C24.8625,4.83125 24.31875,5.3625 23.64375,5.3625 C22.975,5.3625 22.43125,4.83125 22.43125,4.175 C22.43125,3.51875 22.975,2.9875 23.64375,2.9875 L23.64375,2.9875 Z M23.64375,8.18125 C24.31875,8.18125 24.8625,8.70625 24.8625,9.36875 C24.8625,10.025 24.31875,10.55 23.64375,10.55 C22.975,10.55 22.43125,10.01875 22.43125,9.36875 C22.4375,8.70625 22.975,8.18125 23.64375,8.18125 L23.64375,8.18125 Z M20.9875,5.58125 C21.6625,5.58125 22.20625,6.1125 22.20625,6.76875 C22.20625,7.425 21.6625,7.95625 20.9875,7.95625 C20.31875,7.95625 19.775,7.425 19.775,6.76875 C19.775,6.1125 20.31875,5.58125 20.9875,5.58125 L20.9875,5.58125 Z M6.5,6.33125 C6.5,6.1625 6.6125,6 6.76875,6 L6.8375,6 L9,6 L9,3.6125 L9,3.575 C9,3.4 9.13125,3.25 9.3,3.25 L10.66875,3.25 C10.8375,3.25 11.00625,3.4 11.00625,3.575 L11.00625,3.60625 L11.00625,6 L13.33125,6 L13.36875,6 C13.5375,6 13.69375,6.15625 13.69375,6.33125 L13.69375,7.6875 C13.69375,7.86875 13.5375,8 13.36875,8 L13.3375,8 L11,8 L11,10.4125 L11,10.44375 C11,10.61875 10.83125,10.75 10.6625,10.75 L9.29375,10.75 C9.13125,10.75 8.99375,10.63125 8.99375,10.46875 L8.99375,10.4 L8.99375,8 L6.81875,8 L6.7875,8 C6.61875,8 6.5,7.86875 6.5,7.6875 L6.5,6.33125 L6.5,6.33125 Z",
    id: "Shape"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGames);
export default __webpack_public_path__ + "static/media/games.90cd9b8a6c3cee713a30edbe30f6d0f1.svg";
export { ForwardRef as ReactComponent };